import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/AuthProvider';
import Login from './components/authentication/Login';
import DeveloperRoute from './routes/DeveloperRoute';
import AdminRoute from './routes/AdminRoute4';
import AdminRoute2 from './routes/AdminRoute2';
import CreatorsSuiteApp from './components/admin/CreatorSuite';
import AdminRoute3 from './routes/AdminRoute3';
import { LocationsProvider } from './hooks/useLocations';
import Unauthorized from './application/authentication/Unauthorized';
// Import your other components/pages here

const App: React.FC = () => {
  return (
    <AuthProvider>
      <LocationsProvider>
      <Router>
        <Routes>

          <Route path="/" element={<AdminRoute />} />

          {/* <Route path="/" element={<AdminRoute2 />} /> */}

          {/* Login Route */}
          <Route path="/login" element={<Login />} />

          <Route path="/unauthorized" element={<Unauthorized />} />
          
          {/* Developer Control Panel Route */}
          <Route path="/cp/*" element={<DeveloperRoute />} />
          
          {/* Admin Panel Route */}
          <Route path="/admin/*" element={<AdminRoute />} />

          {/* Admin Panel Route */}
          <Route path="/admin2/*" element={<AdminRoute2 />} />

          <Route path="/collections/*" element={<AdminRoute3 />} />


          <Route path="/creator" element={<CreatorsSuiteApp /> } />
          
          {/* Add your other routes here */}
          {/* <Route path="/" element={<Home />} /> */}
          {/* <Route path="/account" element={<Account />} /> */}
          
          {/* Add a catch-all route for 404 if needed */}
          {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
      </Router>
      </LocationsProvider>
    </AuthProvider>
  );
};

export default App;